var _rect, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E2F0FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_1837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E2F0FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.00345 13.0949C7.99999 13.5219 7.99999 13.9753 8 14.4559V18.6792C7.99998 20.0955 7.99997 21.2373 8.1055 22.1457C8.21468 23.0858 8.44711 23.8912 8.99436 24.5735C9.19524 24.824 9.42219 25.052 9.67134 25.254C10.3501 25.8041 11.1513 26.0377 12.0865 26.1475C12.9903 26.2535 14.2901 26.2536 15.699 26.2536C16.2253 26.2543 16.6912 26.2549 17.1302 26.0992C17.2207 26.0671 17.3094 26.0301 17.396 25.9886C17.8159 25.7866 18.145 25.455 18.5166 25.0805L22.9332 20.6409C23.3648 20.2085 23.7478 19.8246 23.9547 19.3225C24.1616 18.8204 24.1608 18.2767 24.1599 17.6642L24.1597 14.4559C24.1598 12.8104 24.1598 11.484 24.0203 10.4408C23.8754 9.35776 23.5655 8.44586 22.845 7.72161C22.1245 6.99735 21.2173 6.68584 20.1398 6.54023C19.1021 6.39998 17.7826 6.4 16.1455 6.40003C15.6422 6.40002 15.1564 6.40001 14.6948 6.40408V8.93945H16.3108C17.4583 8.93945 18.3886 9.86967 18.3886 11.0172C18.3886 12.1646 17.4583 13.0949 16.3108 13.0949H14.6948V14.7109C14.6948 15.8583 13.7646 16.7886 12.6171 16.7886C11.4696 16.7886 10.5394 15.8583 10.5394 14.7109V13.0949H8.00345Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1303 26.0992C17.2208 26.0671 17.3095 26.0301 17.396 25.9886C17.816 25.7866 18.145 25.455 18.5167 25.0805L22.9333 20.6409C23.3649 20.2085 23.7479 19.8246 23.9548 19.3225C24.046 19.1011 24.0969 18.8716 24.1251 18.6318H22.296C21.0331 18.6318 20.4342 18.6326 19.6337 18.7402C18.8024 18.8519 18.1026 19.091 17.5468 19.6468C16.9909 20.2027 16.7518 20.9025 16.6401 21.7336C16.5327 22.5326 16.5327 23.1384 16.5327 24.396V26.2272C16.739 26.206 16.9373 26.1676 17.1303 26.0992Z",
    fill: "#005DAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6171 6.40002C13.1271 6.40002 13.5406 6.81346 13.5406 7.32345V10.0937H16.3108C16.8208 10.0937 17.2343 10.5072 17.2343 11.0172C17.2343 11.5271 16.8208 11.9406 16.3108 11.9406H13.5406V14.7109C13.5406 15.2209 13.1271 15.6343 12.6171 15.6343C12.1071 15.6343 11.6937 15.2209 11.6937 14.7109V11.9406H8.92343C8.41344 11.9406 8 11.5271 8 11.0172C8 10.5072 8.41344 10.0937 8.92343 10.0937H11.6937V7.32345C11.6937 6.81346 12.1071 6.40002 12.6171 6.40002Z",
    fill: "#005DAC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/fileUpload.50b98a8a4d50f636ef34d2c3c054e47c.svg";
export { ForwardRef as ReactComponent };